(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["patina-release-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('PatinaReleaseSignup');
    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-patina-signup-close]');
    const emailInput = modal.querySelector('input[type="email"]');
    const productHandle = modal.dataset.productHandle || 'general';
    const sessionKey = `patina-signup-dismissed-${productHandle}`;
    let returnFocus = null;

    const openModal = (trigger) => {
      returnFocus = trigger || document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => emailInput?.focus(), 220);
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      sessionStorage.setItem(sessionKey, 'true');
      returnFocus?.focus?.();
    };

    document.querySelectorAll('a[href="#PatinaReleaseSignup"]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openModal(trigger);
      });
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (modal.dataset.autoOpen === 'true' && sessionStorage.getItem(sessionKey) !== 'true') {
      window.setTimeout(() => openModal(), 900);
    }

    if (modal.querySelector('.patina-signup__success, .patina-signup__error')) openModal();
  })();
  } catch(e) { console.error(e); }
})();

})();
